<template>

	<AppLayout>
		<template #default>

			<AuthorizedWindow/>

		</template>
	</AppLayout>

</template>

<script setup>
// RISK(RISK-028)[S3/UX]: FMS не уведомляет пользователя о новом релизе — PwaReloadPrompt подключён
// только в scouting, здесь его нет; вместе с отсутствием router.onError это значит, что после деплоя
// пользователь ловит протухшие динамические чанки без предложения перезагрузки. Решение: проверка
// версии/чанков + prompt обновления. Подробнее: docs/audit/04_risks_register.md (RISK-028)
import AppLayout from '@/layouts/AppLayout.vue'
import AuthorizedWindow from '@/components/windows/AuthorizedWindow.vue'
</script>
